import DOMPurify from "dompurify";
import { cn } from "../../lib/cn.js";

/**
 * Renders admin-authored HTML safely. TipTap output is already sanitized
 * server-side; DOMPurify is defense in depth on the client.
 */
export function RichText({ html, className }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  return (
    <div className={cn("prose-dark", className)} dangerouslySetInnerHTML={{ __html: clean }} />
  );
}
